// extracted by mini-css-extract-plugin
module.exports = {"shyftPassSingleClassPage":"ShyftPassSingleClassPage_shyftPassSingleClassPage__jYjro"};